// It return the file size in a human readable size (KB).
// file = this.$refs.logoInput.files[0];
export default function (file) {
  return Math.round(file.size / 1024)
}
